import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";
import { TypeEnum, TypeEnumConverter } from "../enum/type.enum";

@JsonConverter
export class ComponentConverter implements JsonCustomConvert<Component> {
  serialize() { }
  deserialize(data: any): Component {
    const component = new Component();
    component.code = data?.code ?? "";
    component.value = Number(data?.value ?? 0);
    return component;
  }
}

@JsonConverter
export class ComponentArrayConverter implements JsonCustomConvert<Array<Component>> {
    serialize() { }
    deserialize(data: any): Array<Component> {
      const converter = new ComponentConverter();
      return (data ?? []).map((item: any) => converter.deserialize(item));
    }
}

@JsonObject("Component")
export class Component {
    @JsonProperty("code", String, true)
    code: string = "";
    @JsonProperty("value", Number, true)
    value: number = 0;
}


@JsonObject("ComponentData")
export class ComponentData extends BaseResponse {
    @JsonProperty("data", ComponentConverter, true)
    data: Component = new Component();
}

@JsonObject("ComponentDataArray")
export class ComponentDataArray extends BaseResponse {
    @JsonProperty("data", ComponentArrayConverter, true)
    data: Array<Component> = [];
} 
